












































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { answersApi } from '../services/answers';
import { QuestionViewModel } from '../models/answers/questionViewModel';
import shortid from 'shortid';
import { Action, Getter } from 'vuex-class';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import EditableText from '@/shared/components/EditableText.vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Draggable from 'vuedraggable';
import { StateViewModel } from '../models/designer';
import TextComponent from './../components/designer/TextComponent.vue';
import AppIntegrationComponent from './../components/designer/AppIntegrationComponent.vue';
import GoToComponent from './../components/designer/GoToComponent.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import TextIcon from 'vue-material-design-icons/FormatTitle.vue';
import GoToIcon from '@/shared/icons/GoToIcon.vue';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import UtteranceList from '@/features/bots/components/designer/UtteranceList.vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import BackArrow from 'vue-material-design-icons/ArrowLeft.vue';
import SaveIcon from 'vue-material-design-icons/ContentSave.vue';
import PauseIcon from 'vue-material-design-icons/Pause.vue';
import PlayIcon from 'vue-material-design-icons/Play.vue';
import appInsights from '@/shared/services/appInsights';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import { Route } from 'vue-router';
import { BOT_STUDIO_ENABLED } from '@/store/app/featureTypes';
import AdvancedTooltip from '@/shared/components/AdvancedTooltip.vue';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';
import FaqIntentPicker from '@/features/bots/components/FaqIntentPicker.vue';
import { CREATE_INTENT, GET_INTENT, LOAD_INTENTS, UPDATE_INTENT } from '@/store/intents/actionTypes';
import { IntentViewModel } from '../models/intents/intentViewModel';
import { SaveIntentViewModel } from '../models/intents/saveIntentViewModel';
import { IntentListItemViewModel } from '../models/intents/intentListItemViewModel';
import { LOAD_ANSWER, UPDATE_ANSWER } from '@/store/answers/actionTypes';
import { UpdateAnswerViewModel } from '../models/answers/updateAnswerViewModel';

const validIntentName = (value: string) => {
	return value.search(/[<>*%&:\\$]/) === -1;
};

@Component({
	mixins: [
		validationMixin
	],
	components: {
		UtteranceList,
		AddIcon,
		HelpIcon,
		DeleteIcon,
		PauseIcon,
		PlayIcon,
		SaveIcon,
		BackArrow,
		TextIcon,
		EditableText,
		LoadingSpinner,
		Draggable,
		TextComponent,
		AppIntegrationComponent,
		DropDownMenu,
		ConfirmationModal,
		BotPreviewModal,
		UpgradeModal,
		AdvancedTooltip,
		FaqIntentPicker,
		GoToComponent,
		GoToIcon
	},
	validations: {
		faqName: {
			required,
			validIntentName
		},
		answerStates: {
			required
		},
		intent: {
			required
		},
		questions: {
			required,
			$each: {
				text: {
					required,
					isUnique(value) {
						return !(this.$v.questions && this.$v.questions.$model.filter((q: any) => q.text === value).length > 1);
					}
				}
			}
		}
	}
})
export default class AnswerEditor extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;
	@Action(LOAD_ANSWER) public loadAnswer!: (answerId: string) => Promise<AnswerViewModel>;
	@Action(UPDATE_ANSWER) public updateAnswer: ({ answerId, request }: { answerId: string, request: UpdateAnswerViewModel }) => Promise<AnswerViewModel>;
	@Action(GET_INTENT) public getIntent!: (id: string) => Promise<IntentViewModel>;
	@Action(CREATE_INTENT) public createIntent: (intent: SaveIntentViewModel) => Promise<IntentViewModel>;
	@Action(UPDATE_INTENT) public updateIntent!: (request: { id: string, intent: SaveIntentViewModel }) => Promise<IntentViewModel>;
	@Action(LOAD_INTENTS) public loadIntents!: (forceLoad: boolean) => Promise<IntentListItemViewModel[]>;
	@Getter public isAnswerTransitioningToAnInactiveFlow: boolean;
	public questions: QuestionViewModel[] = [];
	public faqName: string = '';
	public currentAnswerStatus: FlowStatus = FlowStatus.Draft;
	public hasMadeChanges = false;
	public hasLiveParentFlows = false;
	public isSaveInProgress = false;
	public loadedAnswer = false;
	public loadedFullIntent = false;
	public loadedIntentList = false;
	public isStatePickerUp = false;
	public intentId: string | null = null;
	public intent: Partial<IntentViewModel> | null = null;
	public intents: IntentListItemViewModel[] = [];
	public navigationTo: Route | null = null;

	public answerStates: StateViewModel[] = [];

	public showLeaveModal: boolean = false;
	public showDeleteModal: boolean = false;
	public showMakeLiveModal: boolean = false;
	public showBotPreviewModal: boolean = false;
	public showPauseAnswerModal: boolean = false;
	public showUpgradeModal: boolean = false;

	public existingAnswer: AnswerViewModel | null = null;

	public async mounted() {
		await Promise.all([this.fetchAnswer(), this.fetchIntents()]);
	}

	public onAnswerChange() {
		this.hasMadeChanges = true;
	}

	public async saveAnswer() {
		this.$v.$touch();
		if (this.$v.$invalid || this.answerStates.some(s => s.invalid)) {
			Toast.showError('Fix the errors in red before saving');
			return;
		}
		try {
			appInsights.trackEvent({ name: 'Save answer clicked' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
			this.isSaveInProgress = true;
			this.faqName = this.faqName.trim();

			if (!this.intentId) {
				await this.createNewIntent();
			} else {
				await this.updateExistingIntent();
			}

			await this.updateAnswer({
				answerId: this.answerId,
				request: {
					title: this.faqName,
					intentId: this.intentId!,
					answerStates: this.answerStates,
					status: this.currentAnswerStatus
				}
			});

			this.hasMadeChanges = false;
			Toast.showSuccess('Saved FAQ');
		} catch (ex: any) {
			Toast.showError(ex.message);
		} finally {
			this.isSaveInProgress = false;
		}
	}

	public openPreview() {
		appInsights.trackEvent({ name: 'Preview clicked' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
		this.showBotPreviewModal = true;
	}

	public showMakeAnswerLiveConfirmation() {
		appInsights.trackEvent({ name: 'Make live clicked' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
		this.showMakeLiveModal = true;
	}

	public upgradeButtonClicked() {
		this.showUpgradeModal = true;
	}

	public deleteAnswer() {
		if (!this.canDeleteAnswer) {
			Toast.showError('Cannot delete an FAQ that is transitioned to by another flow');
		} else {
			this.showDeleteModal = true;
		}
	}

	public beforeRouteLeave(to: Route, from: Route, next: any) {
		this.navigationTo = to;
		const forceDiscard = !!to.params.forceDiscard;
		window.setTimeout(async () => { // allow update to be applied before attempting to leave, nextTick doesn't work
			if (forceDiscard || !this.hasMadeChanges) {
				next();
			} else {
				this.showLeaveModal = true;
			}
		}, 100);
	}

	public async discardAnswer(forceDiscard: boolean = false) {
		window.setTimeout(async () => { // allow update to be applied before attempting to leave, nextTick doesn't work
			if (forceDiscard || !this.hasMadeChanges) {
				const route = {
					name: this.navigationTo?.name || 'bots-answers',
					params: {
						forceDiscard: 'true',
						...this.navigationTo?.params
						}
					};
				await this.$router.push(route);
			} else {
				this.showLeaveModal = true;
			}
		}, 100);
	}

	public pauseAnswer() {
		appInsights.trackEvent({ name: 'Pause answer clicked' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
		if (!this.canPauseAnswer) {
			Toast.showError(this.pauseAnswerErrorMessage);
			return;
		}
		this.showPauseAnswerModal = true;
	}

	public async makeAnswerLive() {
		try {
			this.isSaveInProgress = true;
			const savedAnswer = await this.updateAnswer({
				answerId: this.answerId,
				request: {
					status: FlowStatus.Live
				}
			});
			this.currentAnswerStatus = savedAnswer.status;
			appInsights.trackEvent({ name: 'Made answer live' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
			Toast.showSuccess(`Made FAQ ${this.faqName} live`);
		} catch (error) {
			Toast.showError(`Failed to make FAQ ${this.faqName} live`);
		}
		this.isSaveInProgress = false;
		this.showMakeLiveModal = false;
	}

	public async onDeleteAnswerConfirmed() {
		this.showDeleteModal = false;
		try {
			appInsights.trackEvent({ name: 'Delete answer clicked' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
			await answersApi.deleteAnswer(this.currentWorkspace.id, this.answerId);
			await this.$router.push({
				name: 'bots-answers',
				params: {
					forceDiscard: 'true'
				}
			});
			Toast.showSuccess('Deleted FAQ');
		} catch (ex: any) {
			Toast.showError('Failed to delete FAQ : ' + ex.message);
		}
	}

	public async onPauseAnswerConfirmed() {
		try {
			this.isSaveInProgress = true;
			const savedAnswer = await this.updateAnswer({
				answerId: this.answerId,
				request: {
					status: FlowStatus.Paused
				}
			});
			this.currentAnswerStatus = savedAnswer.status;
			appInsights.trackEvent({ name: 'Answer paused' }, { answerId: this.answerId, workspaceId: this.currentWorkspace.id });
			Toast.showSuccess(`Paused ${this.faqName}`);
		} catch (error) {
			Toast.showError(`Failed to pause FAQ ${this.faqName}`);
		}
		this.isSaveInProgress = false;
		this.showPauseAnswerModal = false;
	}

	public getDeleteAnswerConfirmationMessage() {
		return `Are you sure you want to delete the <b>${HtmlFormatter.escapeHtmlCharacters(this.faqName)}</b> FAQ? The action is irreversible. Please type the name of the FAQ to confirm:`;
	}

	public setFaqName(text: string, previousValue: string) {
		if (text !== previousValue) {
			this.faqName = text;
			this.onAnswerChange();
		}
	}

	public getStateComponentName(state: StateViewModel) {
		if (state.component === 'InputString' && state.options && state.options.length > 0) {
			return 'QuickReplyComponent';
		}

		return `${state.component}Component`;
	}

	public addMessageState() {
		this.addState({
			id: `state-${shortid.generate()}`,
			component: 'Text',
			text: ''
		});
		this.onAnswerChange();
	}

	public addAppIntegrationState() {
		this.addState({
			id: `state-${shortid.generate()}`,
			component: 'AppIntegration',
		});
		this.onAnswerChange();
	}

	public addGoToState() {
		this.answerStates.push({
			id: `state-${shortid.generate()}`,
			component: 'GoTo',
			transition: {
				type: undefined,
				payload: undefined
			},
			invalid: true
		});
		this.onAnswerChange();
	}

	public deleteState(state: StateViewModel) {
		this.answerStates = this.answerStates.filter(s => s.id !== state.id);
		this.onAnswerChange();
	}

	public stateUpdated(state: StateViewModel) {
		const index = this.answerStates.findIndex(s => s.id === state.id);
		this.answerStates[index] = state;
		this.onAnswerChange();
	}

	public clearTransform(event: any) {
		// this is a fix for the modal within a state not appearing correctly after the state is dragged
		// the modal is position:fixed which can be relative to a parent that has a transform style, which we don't want.
		// see https://github.com/SortableJS/Sortable/issues/1687
		event.item.style.transform = null;
	}

	public setIsStatePickerUp(val: boolean) {
		this.isStatePickerUp = val;
	}

	public get faqNameErrorText() {
		const vuelidateFaqNameField = (this.$v as any).faqName;

		if (vuelidateFaqNameField.$error && vuelidateFaqNameField.required && !vuelidateFaqNameField.validIntentName) {
			return 'Must not contain &lt;, &gt;, *, %, &amp;, :, \\, $';
		}
		return '';
	}

	public isMakeLiveButtonVisible() {
		return this.isStatus(FlowStatus.Paused, FlowStatus.Draft);
	}

	public isPauseOptionVisible() {
		return this.isStatus(FlowStatus.Live);
	}

	public getLeaveConfirmationMessage() {
		return `All changes you've made to <b>${HtmlFormatter.escapeHtmlCharacters(this.faqName)}</b> will be discarded. <br/>Are you sure you want to leave the page?`;
	}

	public getMakeLiveConfirmationMessage() {
		return `This will make the FAQ active to your audience. Are you sure you want to continue?`;
	}

	public get previewFlowHoverMessage() {
		if (this.hasMadeChanges) {
			return 'Cannot preview an FAQ with unsaved changes';
		}
		return '';
	}

	public getPauseConfirmationMessage() {
		return `This will prevent the FAQ from being triggered. Are you sure you want to continue?`;
	}

	public get saveAnswerHoverMessage() {
		if (!this.hasMadeChanges) {
			return 'No changes to save';
		}
		return '';
	}

	public get makeLiveHoverMessage() {
		if (this.isAnswerTransitioningToAnInactiveFlow) {
			return 'Must not transition to flow that is not live';
		}
		if (this.hasMadeChanges) {
			return 'Cannot make FAQ live with unsaved changes';
		}
		return '';
	}

	public get isPreviewButtonEnabled() {
		return !this.hasMadeChanges && !this.isSaveInProgress && this.intentId;
	}

	public get pauseAnswerErrorMessage() {
		if (this.hasLiveParentFlows) {
			return 'Cannot pause an FAQ that is transitioned to by a live flow';
		}
		if (this.hasMadeChanges) {
			return 'Cannot pause an FAQ with unsaved changes';
		}
		return '';
	}

	public get isSaveButtonEnabled() {
		return !this.isSaveInProgress && this.hasMadeChanges;
	}

	public get canMakeLive() {
		return !this.hasMadeChanges && !this.isSaveInProgress && this.isBotStudioEnabled() && this.intentId && !this.isAnswerTransitioningToAnInactiveFlow;
	}

	public get canPauseAnswer() {
		return this.currentAnswerStatus === FlowStatus.Live && !this.hasLiveParentFlows && !this.hasMadeChanges;
	}

	public get canDeleteAnswer() {
		return !this.hasLiveParentFlows;
	}

	public get answerId() {
		return this.$route.params.id;
	}

	public isBotStudioEnabled() {
		return this.isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED);
	}

	public async handleIntentChange(intent: Partial<IntentListItemViewModel>) {
		const hasChangedIntent = intent.id !== this.intentId && intent.title !== this.intent?.title;
		const isInitialChangeToFaqNameIntent = this.intent === null && intent.title === this.faqName;
		if (hasChangedIntent && !isInitialChangeToFaqNameIntent) {
			this.onAnswerChange();
		}
		if (this.intentId !== intent.id) {
			this.questions = [{ id: shortid.generate(), text: '' }];
		}
		this.intent = intent;
		this.intentId = intent.id!;
		this.loadedFullIntent = false;
		await this.loadFullIntent();
		this.loadedFullIntent = true;
	}

	public async loadFullIntent() {
		if (!this.intentId) {
			return;
		}
		this.intent = await this.getIntent(this.intentId);
		this.questions = this.intent.utterances || [{ id: shortid.generate(), text: '' }];
	}

	public containsGoToState() {
		return this.answerStates?.some(s => s.component === 'GoTo');
	}

	public get endStates(): StateViewModel[] {
		return this.answerStates?.filter(s => s.component === 'GoTo') || [];
	}

	public get nonEndStates(): StateViewModel[] {
		return this.answerStates?.filter(s => s.component !== 'GoTo') || [];
	}

	public handleIntentListLoaded() {
		this.loadedIntentList = true;
	}

	private async fetchAnswer() {
		this.existingAnswer = await this.loadAnswer(this.answerId);
		this.intentId = this.existingAnswer.intentId;
		this.faqName = this.existingAnswer.title;

		this.answerStates = this.existingAnswer.answerStates.map(s => {
			s.id = `state-${shortid.generate()}`;
			return s;
		});

		this.hasLiveParentFlows = this.existingAnswer.parentFlowIds && this.existingAnswer.parentFlowIds.length > 0;
		this.currentAnswerStatus = this.existingAnswer.status;
		if (this.answerStates.length === 0) {
			this.addMessageState();
		}

		this.loadedAnswer = true;

		this.$nextTick(() => {
			this.hasMadeChanges = false;
		});
	}

	private async fetchIntents() {
		this.intents = await this.loadIntents(true);
		this.loadedIntentList = true;
	}

	private isStatus(...allowedStatuses: FlowStatus[]): boolean {
		return allowedStatuses.includes(this.currentAnswerStatus);
	}

	private async createNewIntent() {
		if (!this.intent || !this.intent.title) {
			return;
		}
		const newIntent = await this.createIntent({
			title: this.intent.title,
			utterances: this.questions.map(q => q.text),
		});
		this.intentId = newIntent.id;
	}

	private async updateExistingIntent() {
		if (!this.intent || !this.intent.title) {
			return;
		}
		await this.updateIntent({
			id: this.intentId!,
			intent: {
				title: this.intent.title,
				utterances: this.questions.map(q => q.text),
			}
		});
	}

	private addState(state: StateViewModel): void {
		if (this.endStates.length > 0) {
			this.answerStates.splice(this.answerStates.length - 1, 0, state);
			return;
		}
		this.answerStates.push(state);
	}
}
